export const CURRENCY_SYMBOLS = {
    AED: { code: 'AED', symbol: 'د.إ' },
    AFN: { code: 'AFN', symbol: '؋' },
    ALL: { code: 'ALL', symbol: 'L' },
    AMD: { code: 'AMD', symbol: '֏' },
    ANG: { code: 'ANG', symbol: 'ƒ' },
    AOA: { code: 'AOA', symbol: 'Kz' },
    ARS: { code: 'ARS', symbol: '$' },
    AUD: { code: 'AUD', symbol: '$' },
    AWG: { code: 'AWG', symbol: 'ƒ' },
    AZN: { code: 'AZN', symbol: '₼' },
    BAM: { code: 'BAM', symbol: 'KM' },
    BBD: { code: 'BBD', symbol: '$' },
    BDT: { code: 'BDT', symbol: '৳' },
    BGN: { code: 'BGN', symbol: 'лв' },
    BHD: { code: 'BHD', symbol: '.د.ب' },
    BIF: { code: 'BIF', symbol: 'FBu' },
    BMD: { code: 'BMD', symbol: '$' },
    BND: { code: 'BND', symbol: '$' },
    BOB: { code: 'BOB', symbol: '$b' },
    BRL: { code: 'BRL', symbol: 'R$' },
    BSD: { code: 'BSD', symbol: '$' },
    BTC: { code: 'BTC', symbol: '฿' },
    BTN: { code: 'BTN', symbol: 'Nu.' },
    BWP: { code: 'BWP', symbol: 'P' },
    BYR: { code: 'BYR', symbol: 'Br' },
    BYN: { code: 'BYN', symbol: 'Br' },
    BZD: { code: 'BZD', symbol: 'BZ$' },
    CAD: { code: 'CAD', symbol: '$' },
    CDF: { code: 'CDF', symbol: 'FC' },
    CHF: { code: 'CHF', symbol: 'CHF' },
    CLP: { code: 'CLP', symbol: '$' },
    CNY: { code: 'CNY', symbol: '¥' },
    COP: { code: 'COP', symbol: '$' },
    CRC: { code: 'CRC', symbol: '₡' },
    CUC: { code: 'CUC', symbol: '$' },
    CUP: { code: 'CUP', symbol: '₱' },
    CVE: { code: 'CVE', symbol: '$' },
    CZK: { code: 'CZK', symbol: 'Kč' },
    DJF: { code: 'DJF', symbol: 'Fdj' },
    DKK: { code: 'DKK', symbol: 'kr' },
    DOP: { code: 'DOP', symbol: 'RD$' },
    DZD: { code: 'DZD', symbol: 'دج' },
    EEK: { code: 'EEK', symbol: 'kr' },
    EGP: { code: 'EGP', symbol: '£', isSymbolToTheLeft: true },
    ERN: { code: 'ERN', symbol: 'Nfk' },
    ETB: { code: 'ETB', symbol: 'Br' },
    ETH: { code: 'ETH', symbol: 'Ξ' },
    EUR: { code: 'EUR', symbol: '€', delimiter: ',' },
    FJD: { code: 'FJD', symbol: '$' },
    FKP: { code: 'FKP', symbol: '£', isSymbolToTheLeft: true },
    GBP: { code: 'GBP', symbol: '£', isSymbolToTheLeft: true, delimiter: '.' },
    GEL: { code: 'GEL', symbol: '₾' },
    GGP: { code: 'GGP', symbol: '£', isSymbolToTheLeft: true },
    GHC: { code: 'GHC', symbol: '₵' },
    GHS: { code: 'GHS', symbol: 'GH₵' },
    GIP: { code: 'GIP', symbol: '£', isSymbolToTheLeft: true },
    GMD: { code: 'GMD', symbol: 'D' },
    GNF: { code: 'GNF', symbol: 'FG' },
    GTQ: { code: 'GTQ', symbol: 'Q' },
    GYD: { code: 'GYD', symbol: '$' },
    HKD: { code: 'HKD', symbol: '$' },
    HNL: { code: 'HNL', symbol: 'L' },
    HRK: { code: 'HRK', symbol: 'kn' },
    HTG: { code: 'HTG', symbol: 'G' },
    HUF: { code: 'HUF', symbol: 'Ft' },
    IDR: { code: 'IDR', symbol: 'Rp' },
    ILS: { code: 'ILS', symbol: '₪' },
    IMP: { code: 'IMP', symbol: '£', isSymbolToTheLeft: true },
    INR: { code: 'INR', symbol: '₹' },
    IQD: { code: 'IQD', symbol: 'ع.د' },
    IRR: { code: 'IRR', symbol: '﷼' },
    ISK: { code: 'ISK', symbol: 'kr' },
    JEP: { code: 'JEP', symbol: '£', isSymbolToTheLeft: true },
    JMD: { code: 'JMD', symbol: 'J$' },
    JOD: { code: 'JOD', symbol: 'JD' },
    JPY: { code: 'JPY', symbol: '¥' },
    KES: { code: 'KES', symbol: 'KSh' },
    KGS: { code: 'KGS', symbol: 'лв' },
    KHR: { code: 'KHR', symbol: '៛' },
    KMF: { code: 'KMF', symbol: 'CF' },
    KPW: { code: 'KPW', symbol: '₩' },
    KRW: { code: 'KRW', symbol: '₩' },
    KWD: { code: 'KWD', symbol: 'KD' },
    KYD: { code: 'KYD', symbol: '$' },
    KZT: { code: 'KZT', symbol: 'лв' },
    LAK: { code: 'LAK', symbol: '₭' },
    LBP: { code: 'LBP', symbol: '£', isSymbolToTheLeft: true },
    LKR: { code: 'LKR', symbol: '₨' },
    LRD: { code: 'LRD', symbol: '$' },
    LSL: { code: 'LSL', symbol: 'M' },
    LTC: { code: 'LTC', symbol: 'Ł' },
    LTL: { code: 'LTL', symbol: 'Lt' },
    LVL: { code: 'LVL', symbol: 'Ls' },
    LYD: { code: 'LYD', symbol: 'LD' },
    MAD: { code: 'MAD', symbol: 'MAD' },
    MDL: { code: 'MDL', symbol: 'lei' },
    MGA: { code: 'MGA', symbol: 'Ar' },
    MKD: { code: 'MKD', symbol: 'ден' },
    MMK: { code: 'MMK', symbol: 'K' },
    MNT: { code: 'MNT', symbol: '₮' },
    MOP: { code: 'MOP', symbol: 'MOP$' },
    MRO: { code: 'MRO', symbol: 'UM' },
    MRU: { code: 'MRU', symbol: 'UM' },
    MUR: { code: 'MUR', symbol: '₨' },
    MVR: { code: 'MVR', symbol: 'Rf' },
    MWK: { code: 'MWK', symbol: 'MK' },
    MXN: { code: 'MXN', symbol: '$' },
    MYR: { code: 'MYR', symbol: 'RM' },
    MZN: { code: 'MZN', symbol: 'MT' },
    NAD: { code: 'NAD', symbol: '$' },
    NGN: { code: 'NGN', symbol: '₦' },
    NIO: { code: 'NIO', symbol: 'C$' },
    NOK: { code: 'NOK', symbol: 'kr' },
    NPR: { code: 'NPR', symbol: '₨' },
    NZD: { code: 'NZD', symbol: '$' },
    OMR: { code: 'OMR', symbol: '﷼' },
    PAB: { code: 'PAB', symbol: 'B/.' },
    PEN: { code: 'PEN', symbol: 'S/.' },
    PGK: { code: 'PGK', symbol: 'K' },
    PHP: { code: 'PHP', symbol: '₱' },
    PKR: { code: 'PKR', symbol: '₨' },
    PLN: { code: 'PLN', symbol: 'zł' },
    PYG: { code: 'PYG', symbol: 'Gs' },
    QAR: { code: 'QAR', symbol: '﷼' },
    RMB: { code: 'RMB', symbol: '￥' },
    RON: { code: 'RON', symbol: 'lei' },
    RSD: { code: 'RSD', symbol: 'Дин.' },
    RUB: { code: 'RUB', symbol: '₽' },
    RWF: { code: 'RWF', symbol: 'R₣' },
    SAR: { code: 'SAR', symbol: '﷼' },
    SBD: { code: 'SBD', symbol: '$' },
    SCR: { code: 'SCR', symbol: '₨' },
    SDG: { code: 'SDG', symbol: 'ج.س.' },
    SEK: { code: 'SEK', symbol: 'kr' },
    SGD: { code: 'SGD', symbol: '$' },
    SHP: { code: 'SHP', symbol: '£', isSymbolToTheLeft: true },
    SLL: { code: 'SLL', symbol: 'Le' },
    SOS: { code: 'SOS', symbol: 'S' },
    SRD: { code: 'SRD', symbol: '$' },
    SSP: { code: 'SSP', symbol: '£', isSymbolToTheLeft: true },
    STD: { code: 'STD', symbol: 'Db' },
    STN: { code: 'STN', symbol: 'Db' },
    SVC: { code: 'SVC', symbol: '$' },
    SYP: { code: 'SYP', symbol: '£', isSymbolToTheLeft: true },
    SZL: { code: 'SZL', symbol: 'E' },
    THB: { code: 'THB', symbol: '฿' },
    TJS: { code: 'TJS', symbol: 'SM' },
    TMT: { code: 'TMT', symbol: 'T' },
    TND: { code: 'TND', symbol: 'د.ت' },
    TOP: { code: 'TOP', symbol: 'T$' },
    TRL: { code: 'TRL', symbol: '₤' },
    TRY: { code: 'TRY', symbol: '₺' },
    TTD: { code: 'TTD', symbol: 'TT$' },
    TVD: { code: 'TVD', symbol: '$' },
    TWD: { code: 'TWD', symbol: 'NT$' },
    TZS: { code: 'TZS', symbol: 'TSh' },
    UAH: { code: 'UAH', symbol: '₴' },
    UGX: { code: 'UGX', symbol: 'USh' },
    USD: { code: 'USD', symbol: '$', isSymbolToTheLeft: true, delimiter: '.' },
    UYU: { code: 'UYU', symbol: '$U' },
    UZS: { code: 'UZS', symbol: 'лв' },
    VEF: { code: 'VEF', symbol: 'Bs' },
    VND: { code: 'VND', symbol: '₫' },
    VUV: { code: 'VUV', symbol: 'VT' },
    WST: { code: 'WST', symbol: 'WS$' },
    XAF: { code: 'XAF', symbol: 'FCFA' },
    XBT: { code: 'XBT', symbol: 'Ƀ' },
    XCD: { code: 'XCD', symbol: '$' },
    XOF: { code: 'XOF', symbol: 'CFA' },
    XPF: { code: 'XPF', symbol: '₣' },
    YER: { code: 'YER', symbol: '﷼' },
    ZAR: { code: 'ZAR', symbol: 'R' },
    ZWD: { code: 'ZWD', symbol: 'Z$' },
};
